const isEnglish = (text: string) => {
  return /^[A-Za-z]*$/.test(text)
}

export default isEnglish
